import script from "./CaskLongTextInputSimple.vue?vue&type=script&setup=true&lang=js"
export * from "./CaskLongTextInputSimple.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__
import QInput from 'quasar/src/components/input/QInput.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QInput});
